import store from '@/store';
export default {
  $_isAvailableFactory(factoryId) {
    const currentUser = store.state.stone_auth.currentUser;
    if (
      !currentUser ||
      !currentUser.factories ||
      !currentUser.factories.length
    ) {
      return false;
    }
    const isFactoryInUserFactories = this.$_findFactory(factoryId, currentUser.factory_ids)
    return isFactoryInUserFactories
  },
  $_findFactory(tarFactoryId, factory_ids) {
    return factory_ids.some(id => id == tarFactoryId);
  },
  $_isAvailableOrganization(organizationId) {
    let currentUser = store.state.stone_auth.currentUser;
    if (
      !currentUser ||
      !currentUser.organizations ||
      !currentUser.organizations.length
    ) {
      return false;
    }
    const _organization = currentUser.organizations.find((organization) => {
      return organization.id == organizationId;
    });
    if (!_organization) {
      return false;
    } else {
      return true;
    }
  },
  $_invalidPopupOpen(setting) {
    //判斷factoryId,organizationId有沒有權限
    let is_available = true;
    let _params = setting.params;
    if (_params.factoryId) {
      is_available = this.$_isAvailableFactory(_params.factoryId);
    } else if (_params.organizationId) {
      is_available = this.$_isAvailableOrganization(_params.organizationId);
    }
    if (!is_available) {
      //打開無權限popup
      if (_params.factoryId) {
        store.dispatch('error/setErrorMessage', 'invalid factory scopes');
      } else {
        store.dispatch('error/setErrorMessage', 'invalid organization scopes');
      }
      store.dispatch('error/setErrorTrue');
    }
    return is_available;
  },
};
